import { create } from "zustand";
import { getActivityTrackingFilters, getActivitySummary } from "../api_layers/api";

export const useActivityTracking = create((set) => ({
  // Remove the log update states and logic
  filtersLoading: false,
  activitySummaryLoading: false,
  filters: [],
  activitySummary: [],
  error: null,
  totalRows: 0,

  // Fetch activity tracking filters
  fetchActivityTrackingFilters: async () => {
    try {
      set({ filtersLoading: true, error: null });
      const response = await getActivityTrackingFilters();
      set({ filters: response.data, filtersLoading: false });
    } catch (error) {
      set({ error: error.message, filtersLoading: false });
    }
  },

  // Fetch activity summary
  fetchActivitySummary: async (params) => {
    try {
      set({ activitySummaryLoading: true, error: null });
      const response = await getActivitySummary(params);
      set({ totalRows: response?.data?.length, activitySummary: response?.data, activitySummaryLoading: false });
    } catch (error) {
      set({ error: error.message, activitySummaryLoading: false });
    }
  },
}));
